import clsx from 'clsx';

export const groupClassName =
  'bg-background-group dark:bg-background-group-dark rounded p-7 shadow empty:hidden';

export const gapClassName = 'gap-6';

export const animationClassName =
  'animate-in fade-in motion-safe:slide-in-from-bottom-4 fill-mode-backwards';

export const onlyBorderClassName =
  'focus-within:before:bg-brand relative before:absolute before:h-full before:w-2 before:rounded-l z-10 before:animate-in before:fade-in-0 before:duration-300 before:left-0 before:top-0 before:delay-100 focus-within:before:delay-0';

export const growthClassName =
  'motion-safe:focus-within:-mx-4 focus-within:delay-0 delay-100 duration-300';

export const focusWithinClassName = clsx(onlyBorderClassName, growthClassName);
